import { Routes, RouterModule } from "@angular/router";
import { ClassAttendanceVerificationComponent } from "./class-attendance-verification/class-attendance-verification.component";
import { ClassroomAdminComponent } from "./classroom-admin/classroom-admin.component";
import { ViewSectionComponent } from "./view-section/view-section.component";
import { AuthguardService } from "../master/services";

export const SectionRoutes: Routes = [
	// {path:'', redirectTo:'/section/ViewSection', pathMatch:'full'},
	{
		path: "viewsection",
		data: { title: "View Section Info" },
		component: ViewSectionComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "classroomadmin",
		data: { title: "Classroom Administration" },
		component: ClassroomAdminComponent,
		canActivate: [AuthguardService],
	},

	// (NO LONGER USED)
	// NYCDOE only
	// {path:'classattendanceverification', data:{title:'Classroom Attendance Verification'},component:ClassAttendanceVerificationComponent}
];
